import {html, LitElement, svg} from "lit";
import {customElement, property} from "lit/decorators";

import '@carbon/web-components/es/components/file-uploader';
import '@carbon/web-components/es/components/button';
import '@carbon/web-components/es/components/combo-box';
import '@carbon/web-components/es/components/slug';
import '@carbon/web-components/es/components/text-input';
import {FILE_UPLOADER_ITEM_STATE} from "@carbon/web-components/es/components/file-uploader/file-uploader-item";

import upload32 from '@carbon/web-components/es/icons/cloud--upload/32';

import pdqS3Service, {S3UploadFile} from "../services/PdqS3Service";
import {margin, marginRight} from "~src/styles";

@customElement('pdq-s3-upload')
export class PdqS3Upload extends LitElement {
    @property() s3prefix: string|undefined = undefined;
    @property() files: any[] = [];
    @property() prefixes = new Map<string, string>();
    @property() prefixWord = 'prefix'
    @property() fileWord = 'asset'

    static styles = [...marginRight, ...margin]
    
    constructor() {
        super();
        pdqS3Service.prefixes.subscribe(i => {
            this.prefixes = i;
        })
    }


    render(){
        return html`<div class="m-2">
            <cds-combo-box label="Select a ${this.prefixWord}"
                    value-required
                    @cds-combo-box-beingselected="${this.prefixChanged}"
                    @cds-combo-box-beingcleared="${this.prefixCleared}"
            >
                ${Array.from(this.prefixes, ([key, value]) =>
                        html`<cds-combo-box-item
                                style="background-color: white"
                                value="${key}">${value}</cds-combo-box-item>`
                )}
            </cds-combo-box>
            ${this.renderUpload()}
        </div>`;
    }
    prefixChanged(event: CustomEvent){
        this.s3prefix = event.detail.item.value;
    }
    prefixCleared(){
        this.s3prefix = '';
    }
    renderUpload() {
        if (!this.s3prefix)
            return html`<div>${this.prefixWord} must be set before upload.</div>`;
        return html`
            <cds-file-uploader 
                    ?disabled="${!this.s3prefix}"
                    label-title="Upload ${this.fileWord}s"
            >
                <cds-file-uploader-drop-container
                        multiple="true"
                        @cds-file-uploader-drop-container-changed="${this.handleFilesAdded}"
                >
                    ${upload32({
                        'class': 'mr-2',
                        'aria-label': `Upload ${this.fileWord}`,
                        'aria-describedby': 'id-title-1',
                        children: svg`<title id="id-title-1">Upload ${this.fileWord}</title>`, }
                    )}
                    Drag and drop ${this.fileWord}s here or click to upload
                </cds-file-uploader-drop-container>
                ${this.renderFileItems()}
            </cds-file-uploader>
        `;
      }
  async handleFilesAdded(event: CustomEvent) {
    console.log('handleFilesAdded')

    if (event.detail.addedFiles) {
      const filesArray = Array.from(event.detail.addedFiles) as File[];
      for (const f of filesArray) {
          const fileUpload = {
              prefix: this.s3prefix,
              state: FILE_UPLOADER_ITEM_STATE.UPLOADING,
              file: f
          } as S3UploadFile;
          pdqS3Service.uploadFile(fileUpload)
          .then(i => {
              fileUpload.state = FILE_UPLOADER_ITEM_STATE.COMPLETE;
              this.files = [...this.files]
          }).catch(i => {
              fileUpload.state = FILE_UPLOADER_ITEM_STATE.EDIT;
              fileUpload.error = i.message;
              this.files = [...this.files]
          });
          this.files.push(fileUpload)
      }
    }

      this.files = [...this.files]
  }

  handleFileRemoved(fileName: string) {
    console.log('handleFileRemoved')
    const f = this.files.filter(file => file.file.name === fileName)
    if (f.length ===1){
      f[0].controller?.abort();
    }
    this.files = this.files.filter(file => file.file.name !== fileName);

  }

  renderFileItems() {

    return this.files.map(
      (file, idx) => html`
        <cds-file-uploader-item 
          icon-description="Delete this file!"      
          name="${file.file.name}"
          @cds-file-uploader-item-deleted="${() => this.handleFileRemoved(file.name)}"
          state="${file.state}">
          ${file.name}
        </cds-file-uploader-item>
      `
    );
  }
}